module.exports = __webpack_public_path__ + "img/instagram.5ad64c7c.png";